import {Injectable} from '@angular/core';
import {ShipmentListResponse} from '../shipment-list-response';
import { ActivatedRouteSnapshot, convertToParamMap, ParamMap } from '@angular/router';
import {ShipmentListService} from '../shipment-list.service';

import shortUuid from 'short-uuid';
import {ShipmentQueryParameters} from '../shipment-query-parameters';
import {Observable} from 'rxjs/internal/Observable';
import {ShipmentListSettingsService} from './shipment-list-settings.service';

import moment from 'moment';
import {ShipmentStatusFilter} from './shipment-status-filter';

@Injectable()
export class AllShipmentListResolver  {
  constructor(
    private shipmentListService: ShipmentListService,
    private settings: ShipmentListSettingsService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<ShipmentListResponse> {
    const params = convertToParamMap(route.queryParams);

    const page = params.has('page') ? params.get('page') : 1;
    const pageSize = params.has('pageSize') ? +params.get('pageSize') : 20;

    let carrierId: string = params.get('carrier');

    if (carrierId !== null) {
      carrierId = shortUuid().toUUID(carrierId);
    }

    let departmentId: string = params.get('department');

    if (departmentId !== null) {
      departmentId = shortUuid().toUUID(departmentId);
    }

    let offset = 0;

    if (page !== undefined) {
      offset = pageSize * (+page - 1);
    }

    const parameters: ShipmentQueryParameters = {
      carrierId: carrierId,
      departmentId: departmentId,
      offset: offset,
      count: pageSize,
      orderStatus: this.getStatusFilter(params),
      includeShipmentsWithoutOrderBinding: this.getIncludeShipmentsWithoutOrderBinding(params),
      sortBy: params.get('sortBy'),
      sortDirection: params.get('sortDirection'),
      number: params.get('search'),
      receiverName: params.get('search'),
      senderName: params.get('search'),
      updatedAfter: this.settings.getAllShipmentsDateFromFilterValue() != null ? moment(this.settings.getAllShipmentsDateFromFilterValue()).format('YYYY-MM-DD') : null,
      updatedUntil: this.settings.getAllShipmentsDateToFilterValue() != null ? this.adjustAndFormatToDate(this.settings.getAllShipmentsDateToFilterValue()) : null
    };

    return this.shipmentListService.getShipments(parameters);
  }

  private adjustAndFormatToDate(date: Date): string {
    console.log(date)
    if (date == null) {
      return null;
    }
    // Add 1 day to include orders on the to date since we're only use the date-part
    return moment(date).add(1, 'day').format('YYYY-MM-DD');
  }

  private getStatusFilter(params: ParamMap): string {
    try {
      let filter: ShipmentStatusFilter = ShipmentStatusFilter[params.get('status')];

      switch (filter) {
        case ShipmentStatusFilter.NotStarted:
          return 'Unassigned,Offer,Accepted,Expired';
        case ShipmentStatusFilter.Started:
          return 'Started';
        case ShipmentStatusFilter.Assigned:
          return 'Offer';
        case ShipmentStatusFilter.NotAssigned:
          return 'Unassigned';
        case ShipmentStatusFilter.Finished:
          return 'Finished';
        default:
          return null;
      }
    }
    catch (e) {
      return null;
    }
  }

  private getIncludeShipmentsWithoutOrderBinding(params: ParamMap): boolean {
    try {
      let filter: ShipmentStatusFilter = ShipmentStatusFilter[params.get('status')];

      return filter == ShipmentStatusFilter.NotStarted;
    }
    catch (e) {
      return false;
    }
  }
}
